import { Route, Routes } from "react-router-dom";

import GlobalListDetailScreen from "screens/App/CRM/GlobalListOption/GlobalListOptionDetailScreen";
import GlobalListScreen from "screens/App/CRM/GlobalListOption/GlobalListOptionScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const GlobalListRouter = () => {
  return (
    <Routes>
      <Route index element={<GlobalListScreen />} />
      <Route path="detail/:id" element={<GlobalListDetailScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default GlobalListRouter;
